/*───────────────────────────────────────────────────────────────
 📄 File: hooks/sipPhone/sipDtmfUtils.ts
 🧩 Description:
    DTMF frequency table and audio-feedback utility.
    Pure functions — no React state or refs.
    Extracted from useSipPhone.ts.
────────────────────────────────────────────────────────────────*/

/** Dual-tone frequencies for each DTMF digit (row-freq, col-freq). */
export const DTMF_FREQUENCIES: Record<string, [number, number]> = {
    '1': [697, 1209], '2': [697, 1336], '3': [697, 1477],
    '4': [770, 1209], '5': [770, 1336], '6': [770, 1477],
    '7': [852, 1209], '8': [852, 1336], '9': [852, 1477],
    '*': [941, 1209], '0': [941, 1336], '#': [941, 1477],
};

/**
 * Plays a local DTMF audio tone using the Web Audio API.
 * Does nothing if the digit is not in the DTMF table.
 */
export function playDTMFTone(digit: string, duration = 100): void {
    const frequencies = DTMF_FREQUENCIES[digit];
    if (!frequencies) return;

    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
        const [freq1, freq2] = frequencies;

        const osc1 = audioContext.createOscillator();
        const osc2 = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        osc1.frequency.value = freq1;
        osc2.frequency.value = freq2;
        osc1.type = 'sine';
        osc2.type = 'sine';
        gainNode.gain.value = 0.1;

        osc1.connect(gainNode);
        osc2.connect(gainNode);
        gainNode.connect(audioContext.destination);

        const now = audioContext.currentTime;
        osc1.start(now);
        osc2.start(now);
        osc1.stop(now + duration / 1000);
        osc2.stop(now + duration / 1000);

        setTimeout(() => audioContext.close(), duration + 50);
    } catch (err) {
        console.warn('[SIP] Could not play DTMF tone:', err);
    }
}
